import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/wharfs`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/wharfs/${itemId}`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/wharfs`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/wharfs/${itemId}`);
  },
};
